/**
 * Purpose:
 * Signals that a post-merge working-state commit was computed against a store snapshot that another
 * merge has since replaced.
 *
 * Responsibilities:
 * - Tell RegistryStore.mergeAndCommit that the commit persisted NOTHING and the whole merge must be
 *   re-run against a freshly hydrated store
 * - Keep the lost-update protection intact: the losing commit is rejected, never replayed
 *
 * Current behavior:
 * - Thrown by the store's compare-and-swap before any write, so a caught instance always means the
 *   store is exactly as the winning merge left it
 * - Left uncaught (retries spent, or a caller that does not retry) it fails the request exactly as
 *   the previous store-changed error did
 */
export class TransientCommitConflictException extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'TransientCommitConflictException';
        Object.setPrototypeOf(this, TransientCommitConflictException.prototype);
    }
}
